export const CRM_SYNC_STORE_EVENT_NAMES = [
  'flexworker-signed-up',
  'flexworker-updated',
  'create-manual-identity-verification-completed',
  'identity-verification-automatically-approved',
  'identity-verification-approved',
  'flexworker-added-to-flex-pools',
  'flexworker-removed-from-flex-pools',
  'flexworker-work-application-created',
  'flexworker-removed-from-flex-pool',
  'flexworker-company-favorite-removed',
  'flexworker-company-favorite-added',
  'flexworker-last-app-interaction',
] as const;

export const CRM_REMOVAL_STORE_EVENT_NAMES = ['flexworker-archived'] as const;

export type CrmSyncStoreEventName = (typeof CRM_SYNC_STORE_EVENT_NAMES)[number];
export type CrmRemovalStoreEventName = (typeof CRM_REMOVAL_STORE_EVENT_NAMES)[number];
